/** @jsx jsx */
import { jsx, Box, Flex, Container } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Styles
import { baseStyle } from './style';

// Components
import Text, { TEXT_TYPES } from '../text';
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';
import WpLink from '../link';

// Icons
import ArrowIcon from '../../../static/assets/icons/outlined/directions/straight arrows/right.svg';

// Types
import { PageSelector } from '../../@types/pageselector';

export interface BoxItem {
  box: {
    text: string;
    title: string;
    label?: string | null;
    url: string | null;
    iconImage: ImageType;
    pageSelector: PageSelector | null;
  }[];
}

export interface BoxesListProps {
  boxesList: BoxItem;
}

const BoxesList: FunctionComponent<BoxesListProps> = React.memo(
  ({ boxesList }) => (
    <Container>
      <Flex sx={baseStyle.repeaterContainer}>
        {boxesList.box.map(item => {
          const boxContent = (
            <React.Fragment>
              <Box sx={baseStyle.imageContainer}>
                <FluidImage {...item.iconImage} />
              </Box>
              <Box sx={baseStyle.plusContainer}>
                <Text type={TEXT_TYPES.H1_LIGHT}>+</Text>
              </Box>
              <Box sx={baseStyle.textContainer}>
                <Box sx={{ minHeight: '120px' }}>
                  <Text type={TEXT_TYPES.DISPLAY_SUBHEAD}>{item.title}</Text>
                  <Text type={TEXT_TYPES.BODY_2}>{item.text}</Text>
                </Box>
                {item.label && (
                  <Flex sx={baseStyle.linkLabelContainer}>
                    <Text
                      type={TEXT_TYPES.BUTTON}
                      sx={baseStyle.linkLabelText}
                      lines="1"
                    >
                      {item.label}
                    </Text>
                    <ArrowIcon sx={baseStyle.arrowIcon} />
                  </Flex>
                )}
              </Box>
            </React.Fragment>
          );

          if (item.url || item.pageSelector) {
            return (
              <Box sx={baseStyle.itemContainer}>
                <WpLink
                  url={item.url || item.pageSelector?.uri}
                  sx={baseStyle.boxLink}
                >
                  {boxContent}
                </WpLink>
              </Box>
            );
          }

          return <Box sx={baseStyle.itemContainer}>{boxContent}</Box>;
        })}
      </Flex>
    </Container>
  ),
);

export default BoxesList;
